import { render, staticRenderFns } from "./SettingsList.vue?vue&type=template&id=8b6f8abe&scoped=true&"
import script from "./SettingsList.vue?vue&type=script&lang=ts&"
export * from "./SettingsList.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsList.vue?vue&type=style&index=0&id=8b6f8abe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6f8abe",
  null
  
)

export default component.exports